import { closeDialog } from '../../redux/features/dialogs/dialog.slice';
import { saveSubmissionAndRedirect } from '../../redux/features/dialogs/dialog.thunk';

export const GenericDialogActionsConfig = Object.freeze({
  close: closeDialog,
  saveSubmissionAndRedirect,
});
